import Vue from "vue";
export const SET_AUTH_DATA = "SET_AUTH_DATA";
export const SET_CLIENT_APPLICATION_REQUEST = "SET_CLIENT_APPLICATION_REQUEST";
export const UPDATE_UPLOAD_STATUS = "UPDATE_UPLOAD_STATUS";
const mutations = {
  [SET_AUTH_DATA]: (state, {
    token,
    code
  }) => {
    state.token = token;
    state.code = code;
  },
  [SET_CLIENT_APPLICATION_REQUEST]: (state, {
    clientApplicationRequest
  }) => {
    Vue.set(state, "clientApplicationRequest", clientApplicationRequest);
  },
  [UPDATE_UPLOAD_STATUS]: (state, {
    total,
    current
  }) => {
    state.uploadingStatus.current = current;
    state.uploadingStatus.total = total;
  }
};
export default mutations;